import { Map } from 'immutable';

import * as t from '../../actions/dashboardActionType';

const initialState = Map({
  loadingPracticeExamHistory: true,
  practiceExamHistory: {
    exams: [],
    nextWeeklyGenerationAt: null,
    weeklyPracticeExamBuildInProgress: false,
  },
  customPracticeExamHistory: null,
});

const reducer = function practiceExamHistoryReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.SET_PRACTICE_EXAM_HISTORY:
      return state.set('practiceExamHistory', {
        exams: action.practiceExamHistory.exams || [],
        nextWeeklyGenerationAt:
          action.practiceExamHistory.nextWeeklyGenerationAt || null,
        weeklyPracticeExamBuildInProgress:
          action.practiceExamHistory.weeklyPracticeExamBuildInProgress || false,
      });
    case t.SET_IS_LOADING_PRACTICE_EXAM_HISTORY:
      return state.set(
        'loadingPracticeExamHistory',
        action.isLoadingPracticeExamHistory,
      );

    case t.RESET_PRACTICE_EXAM_HISTORY: {
      return state
        .set('loadingPracticeExamHistory', true)
        .set('practiceExamHistory', {
          exams: [],
          nextWeeklyGenerationAt: null,
          weeklyPracticeExamBuildInProgress: false,
        });
    }
    case t.SET_CUSTOM_PRACTICE_EXAM_HISTORY:
      return state.set('customPracticeExamHistory', action.value);

    default:
      return state;
  }
};

export default reducer;
